module.exports = __webpack_public_path__ + "static/media/4ODA14.85cd3b85.jpg";